import clsx from 'clsx';
import { FormattedNumber } from 'react-intl';

import { useForwardAccumulatorTileId } from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { selectForwardAccumulatorScheduleTable } from '@/store/forwardAccumulator/selectors.ts';
import type { AccumulatorScheduleLine } from '@/store/forwardAccumulator/state.ts';
import { useAppSelector } from '@/store/hooks.ts';

type Props = {
  legId: string;
  property: keyof AccumulatorScheduleLine;
  isAmount?: boolean;
};

export const ReadOnlyCellRenderer = ({ legId, property, isAmount = false }: Props) => {
  const tileId = useForwardAccumulatorTileId();

  const scheduleTable =
    useAppSelector((state) => selectForwardAccumulatorScheduleTable(state, tileId, legId)) ??
    ({} as AccumulatorScheduleLine);

  const value = Number(scheduleTable[property]) ?? 0;

  const displayedValue = isAmount ? <FormattedNumber value={value} /> : value;

  const className = clsx('px-1', {
    'text-end': isAmount,
  });

  return (
    <div className={className} style={{ paddingTop: '2px' }}>
      {displayedValue}
    </div>
  );
};
